import Box from "ds/components/Box";
import Link from "ds/components/Link";
import useTypedContext from "hooks/useTypedContext";
import { EnvironmentContext } from "components/Environment/EnvironmentContext";

import { ContextCellComponentProps } from "./types";

const ContextNameCell = ({ context }: ContextCellComponentProps) => {
  const { canCreateAndEditVariables } = useTypedContext(EnvironmentContext);

  return (
    <Box align="center">
      <Link disabled={!canCreateAndEditVariables} href={`/context/${context.contextId}`}>
        {context.contextName}
      </Link>
    </Box>
  );
};

export default ContextNameCell;
